/** @jsxImportSource @emotion/react */
import { useAuthenticator } from '@aws-amplify/ui-react';
import { css } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import type React from 'react';
import type { ReactNode } from 'react';
import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../footer/footer';
import Header from '../header/header';

type ParentProps = {
  children: ReactNode;
};

const theme = createTheme({
  palette: {
    primary: {
      contrastText: '#fff',
      dark: '#108664',
      light: '#46cca6',
      main: '#18C090',
    },
    secondary: {
      contrastText: '#fff',
      dark: '#4d4d4d',
      light: '#8b8b8b',
      main: '#6F6F6F',
    },
  },
});

const theme2 = createTheme({
  palette: {
    primary: {
      contrastText: '#fff',
      dark: '#4d4d4d',
      light: '#8b8b8b',
      main: '#6F6F6F',
    },
  },
});

const Layout: React.FC<ParentProps> = ({ children }) => {
  const location = useLocation();
  // フッターを表示しないページのパス
  const noFooterPaths = ['/login'];
  // 現在のパスがフッターを表示しないリストに含まれているかどうかをチェック
  const showFooter = !noFooterPaths.includes(location.pathname);

  const appBarRef = useRef<HTMLDivElement>(null);
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  const contentStyle = showFooter
    ? css`
        position: fixed;
        top: 0px;
        bottom: 56px;
        left: 0;
        right: 0;
        width: 100%;
        overflow-y: auto;
      `
    : css`
        top: 0px;
        overflow-y: scroll;
        left: 0;
        right: 0;
        width: 100%;
      `;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ThemeProvider theme={theme2}>
        <Header ref={appBarRef} />
      </ThemeProvider>

      <div css={contentStyle}>{children}</div>
      {['authenticated', 'configuring'].includes(authStatus) && showFooter && <Footer />}
    </ThemeProvider>
  );
};

export default Layout;
